import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import { Helmet } from 'react-helmet';

const ResetPassword = () => {
  const [status, setStatus] = useState('initial'); // initial, success, error

  useEffect(() => {
    // This component is a placeholder for Keycloak password reset
    // It will be loaded when the user clicks the reset link from their email
    // Keycloak will handle the actual password reset logic
    setStatus('success');
  }, []);

  return (
    <>
      <Helmet>
        <title>Restablecer Contraseña</title>
      </Helmet>
      <div className="flex flex-col md:flex-row h-screen">
        <div className="w-full md:w-2/3 p-8 overflow-y-auto flex items-center justify-center">
          <div className="w-full md:max-w-md 2xl:max-w-xl">
            <div className="bg-white rounded-xl shadow-xl transform transition-all shadow-md hover:shadow-2xl focus:shadow-2xl">
              <div className="px-4 py-4 md:px-12 md:py-12">
                <div className="text-center">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16">
                    <img
                      src="/logo_dark.jpg"
                      alt="Logo"
                      className="h-16 w-16 rounded-full object-cover cursor-pointer"
                    />
                  </div>

                  <div className="mt-3">
                    <div className="text-2xl font-medium text-gray-900 mb-4">
                      Restablecer contraseña
                    </div>

                    {status === 'success' ? (
                      <div className="text-left">
                        <div className="bg-green-50 p-4 rounded-lg mb-5">
                          <p className="text-green-700 mb-2">
                            Tu contraseña ha sido restablecida correctamente.
                          </p>
                          <p className="text-green-700 mb-2">
                            Ya puedes iniciar sesión con tu nueva contraseña.
                          </p>
                        </div>
                        <Link
                          to="/login"
                          className="flex items-center justify-center rounded-lg text-lg px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white w-full"
                        >
                          <ArrowLeft size={20} className="mr-2" />
                          Ir al inicio de sesión
                        </Link>
                      </div>
                    ) : status === 'error' ? (
                      <div className="text-left">
                        <div className="bg-red-50 p-4 rounded-lg mb-5">
                          <p className="text-red-700 mb-2">
                            Ha ocurrido un error al restablecer tu contraseña.
                          </p>
                          <p className="text-red-700 mb-2">
                            Por favor, solicita un nuevo enlace de
                            restablecimiento o contacta con soporte.
                          </p>
                        </div>
                        <Link
                          to="/login"
                          className="flex items-center justify-center rounded-lg text-lg px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white w-full"
                        >
                          <ArrowLeft size={20} className="mr-2" />
                          Volver al inicio de sesión
                        </Link>
                      </div>
                    ) : (
                      <div className="text-center p-10">
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        <p className="text-gray-600 mt-4">
                          Procesando tu solicitud...
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="hidden md:block w-1/2 bg-cover bg-center"
          style={{ backgroundImage: `url('/login_5.jpg')` }}
        ></div>
      </div>
    </>
  );
};

export default ResetPassword;
